/**
 * @ Author: Housefolios
 * @ Create Time: 2021-09-16 13:21:50
 * @ Modified by: Daniel Clark
 * @ Modified time: 2024-02-02 12:03:47
 * @ Description: Component displayed when all properties are filtered out
 */

import React from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box } from '@mui/material'

export default function AllPropertiesFiltered() {
  return (
    <Box sx={{ textAlign: 'center', p: '3rem' }}>
      <Box sx={[{ borderRadius: '50%', m: 0 }, {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        mr: "0.25rem",
        position: "relative",
        fontSize: "1.2rem",
        transition: "all 0.2s ease-in-out",
        "&:last-child": { mr: 0, marginRight: 0 },
        "& .badge": { position: "absolute", right: 0, bottom: 0 },
        "& svg, & .svg-inline--fa": { display: "block" },
        marginRight: "0.25rem",
      }]}>
        <Box style={{ backgroundColor: '#cfe1fa', color: '#008aff' }} sx={[{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          border: 0,
          height: "130px !important",
          width: "130px !important",
          lineHeight: "130px !important",
          p: 0,
          borderRadius: "50%",
          m: 0,
        }, {
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          mr: "0.25rem",
          position: "relative",
          fontSize: "1.2rem",
          transition: "all 0.2s ease-in-out",
          "&:last-child": { mr: 0, marginRight: 0 },
          "& .badge": { position: "absolute", right: 0, bottom: 0 },
          "& svg, & .svg-inline--fa": { display: "block" },
          marginRight: "0.25rem",
        }]}>
          <FontAwesomeIcon icon={['fas', 'house-chimney']} style={{ display: 'flex', alignSelf: 'center' }} sx={{ fontSize: "2.5rem", fontWeight: "300", lineHeight: "1.2" }} />
        </Box>
      </Box>
      <Box component="h4" sx={{ fontWeight: 700, mt: '1.5rem' }}>
        No Results Match...
      </Box>
      <Box component="p" sx={[{ mb: 0, color: '#a6a6b9' }, { fontSize: "1.15rem !important" }]}>
        The active filters are hiding the properties
      </Box>
    </Box>
  )
}
